import { render, staticRenderFns } from "./DefaultSwedish.vue?vue&type=template&id=4bed2af4&"
import script from "./DefaultSwedish.vue?vue&type=script&lang=js&"
export * from "./DefaultSwedish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports